import React, { useState, lazy, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { filterList, getQueryStringKeys, isInsuracePortalUser } from 'globalutils/fmUtils';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import TopActions from './TopActions';
import { checkServiceProvider } from './serviceProviderConfig';
import UserList from './Components/UserList';

const layout = window?.$environment?.CURRENT_LAYOUT;
const CloseButton = lazy(() => import(`globalcomponents/CloseButton/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({
  history,
  users,
  apiStatus,
  fetchUsers,
  handleDeleteAlert,
  handleResetPassword,
  callback,
  handleRestoreAlert,
  filterSuccess,
  handleExportUser,
  handleImportUser,
  Styled,
  i18n,
  logBook,
  topAction,
  filterButtons,
  setButtons,
  pagination,
  changeRequest,
  request,
  setFilterData,
  setPagination,
  filters,
  setremoveData,
  removeData,
  viewOnly,
  viewExportOptions,
  showFilters,
  showAllUsers,
  isMechanicUser,
  newUI,
}) => {
  const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
  const userRole = getQueryStringKeys(history.location.search, 'role');
  const [initialFlag, setInitialFlag] = React.useState(false);
  const insuracePortalUserRole = isInsuracePortalUser();

  useEffect(() => {
    if (!initialFlag && users.filteredList) {
      if (userRole) {
        const arrayList = [...users.list];
        let a = filterList(arrayList, 'role', userRole);
        setTableData(a);
        if (users.filteredList.length) setInitialFlag(true);
      } else {
        setTableData(users.filteredList);
      }
    } else if (users.filteredList && initialFlag) {
      setTableData(users.filteredList);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users.filteredList]);

  const [isDocClicked, setisDocClicked] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showCompany, setShowCompany] = useState((userRole && userRole == 'driver') || !userRole ? true : false);

  const [tableData, setTableData] = React.useState(users.filteredList);

  const setSelectedIndexfn = (index) => {
    let addValue = 75;
    let mulVal = 38;
    const tenantVal = checkServiceProvider('setSelectedIndexfn', SERVICE_PROVIDER, false);
    if (tenantVal) {
      addValue = tenantVal.addValue;
      mulVal = tenantVal.mulVal;
    } else if (layout === 'NewUi') {
      addValue = 110;
      mulVal = 39;
    }
    setSelectedIndex(addValue + mulVal * index);
  };

  const userFilter = (value, index) => {
    if (value == 'All' || value == 'Driver') setShowCompany(true);
    else setShowCompany(false);
    setisDocClicked(false);
    setButtons(
      filterButtons.length &&
        filterButtons.map((key, i) => {
          if (i === index) return { ...key, selected: true };
          else return { ...key, selected: false };
        })
    );
    setPagination(true);
    if (insuracePortalUserRole) {
      if (value === 'All') {
        filterSuccess(users.list);
      } else {
        const arrayList = [...users.list];
        let a = filterList(arrayList, 'role', value);
        // filterSuccess(a);
        setTableData(a);
      }
    } else setFilterData(value);
    setremoveData('clear');
  };

  const clickedRow = (row, id) => {
    setSelectedIndexfn(row);
  };
  return (
    <>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            {...{
              history,
              users,
              callback,
              filterSuccess,
              handleExportUser,
              handleImportUser,
              Styled,
              i18n,
              logBook,
              setPagination,
              filterButtons,
              setButtons,
              filters,
              setremoveData,
              removeData,
              viewExportOptions,
              isMechanicUser,
              newUI,
            }}
          />
        )}
        {showFilters && (
          <Styled.ButtonsWrapper>
            <div className="userBtnWrapper" id={'userBtnWrapper'}>
              <span className="quickfilter">{i18n.t('users.quickFilter')}</span>
              {filterButtons.length &&
                filterButtons.map((items, index) => {
                  return items.show ? (
                    <Button
                      label={items.label}
                      className={`userFilterButton ${items.selected ? 'active' : ''}`}
                      onClick={() => userFilter(items.type, index)}
                    ></Button>
                  ) : null;
                })}
            </div>
          </Styled.ButtonsWrapper>
        )}
        <Styled.TableWrapper>
          <UserList
            {...{
              request,
              users,
              changeRequest,
              showAllUsers,
              showCompany,
              isMechanicUser,
              tableData,
              apiStatus,
              fetchUsers,
              viewOnly,
              handleResetPassword,
              callback,
              handleDeleteAlert,
              handleRestoreAlert,
              pagination,
              setPagination,
              setisDocClicked,
              clickedRow,
            }}
          />

          {isDocClicked && (
            <Styled.DocContainer selectedindex={selectedIndex} selectedType={''}>
              <CloseButton
                className="ToolsOptionClose"
                icon={mediaUrls.closeIcon}
                onClick={() => {
                  setisDocClicked(false);
                }}
              />
            </Styled.DocContainer>
          )}
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  users: PropTypes.object.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  handleDeleteAlert: PropTypes.func.isRequired,
  handleResetPassword: PropTypes.func.isRequired,
  handleRestoreAlert: PropTypes.func.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  handleExportUser: PropTypes.func.isRequired,
  handleImportUser: PropTypes.func.isRequired,
  handleExportUserTemplate: PropTypes.func.isRequired,
};
